import { Modal } from 'react-bootstrap';
import PurchaseRequestUpdateForm from './PurchaseRequestUpdateForm';

function PurchaseRequestUpdateModal({ show, onHide, initialData, onSubmit }) {
  const handleFormSubmit = (updatedData) => {
    onSubmit(updatedData);  // parent handles actual update logic
    onHide(); // close modal after submit
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Update Purchase Request</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PurchaseRequestUpdateForm
          initialData={initialData}
          onSubmit={handleFormSubmit}
        />
      </Modal.Body>
    </Modal>
  );
}

export default PurchaseRequestUpdateModal;
